module.exports = __webpack_public_path__ + "img/BrowseDataPoints.e5ea194a.png";